/**
 * Aktify Docs Portal URL for the current environment, derived from VITE_HOST.
 *
 * admin.dev.aktify.io   -> docs.dev.aktify.io
 * admin.stage.aktify.io -> docs.stage.aktify.io
 * admin.aktify.io       -> docs.aktify.io
 * admin.local.aktify.io -> docs.dev.aktify.io (local dev points at DEV docs)
 *
 * Returns undefined when VITE_HOST is not set.
 */
export const getDocsUrl = (): string | undefined => {
  const viteHost = import.meta.env.VITE_HOST as string | undefined;
  return viteHost?.replace('admin', 'docs').replace('.local.', '.dev.');
};
